import React from "react"
import { connect } from "react-redux"
import SimpleHeader from "components/Headers/SimpleHeader.js"
import { addUser } from "actions/organization/usersActions"
import Select2 from "react-select2-wrapper"
import NotificationAlert from "react-notification-alert"

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap"

class AccountDetails extends React.Component {
  customersCollection = "customers"
  state = {
    customStyles: {
      name: "",
      nameState: null,
      email: "",
      emailState: null,
      status: "",
      statusState: null,
      checkbox: false,
      checkboxState: null,
      password: "123456",
      orgId: this.props.orgId,
    },
    disableAddUser: false,
  }

  _isValidEmailAddress(email) {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
    return regex.test(email)
  }

  validateCustomStylesForm = () => {
    let newState = this.state.customStyles
    if (newState.fullName === "") {
      newState.fullNameState = "invalid"
    } else {
      newState.firstNameState = "valid"
    }
    if (newState.email === "") {
      newState.emailState = "invalid"
    } else {
      newState.lastNameState = "valid"
    }
    if (newState.status === false) {
      newState.statusState = "invalid"
    } else {
      newState.statusState = "valid"
    }
    if (newState.checkbox === false) {
      newState.checkboxState = "invalid"
    } else {
      newState.checkboxState = "valid"
    }
    this.setState({
      customStyles: newState,
    })
  }

  customStylesForm = (e, stateName) => {
    let newState = this.state.customStyles
    newState[stateName] = e.target.value
    if (stateName === "status") {
      if (e.target.value) {
        newState.statusState = "valid"
      } else {
        newState.statusState = "invalid"
      }
    } else if (stateName === "email") {
      // console.log(e.target.value.trim());
      newState.email = e.target.value.trim()
      if (this._isValidEmailAddress(e.target.value)) {
        newState.emailState = "valid"
      } else {
        newState.emailState = "invalid"
      }
    } else if (stateName === "name") {
      if (e.target.value.trim().length >= 5) {
        newState[stateName] = e.target.value
        newState.nameState = "valid"
      } else {
        newState.nameState = "invalid"
      }
    } else {
      if (e.target.value === "") {
        newState[stateName + "State"] = "invalid"
      } else {
        newState[stateName + "State"] = "valid"
      }
    }
    this.setState({
      customStyles: newState,
    })
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  render() {
    return (
      <>
        <SimpleHeader name="Add User" parentName="Users" />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <h3 className="mb-0">Add User</h3>
                  </CardHeader>
                  <CardBody>
                    <Form className="needs-validation" noValidate>
                      <div className="form-row">
                        <Col className="mb-3" md="4">
                          <label
                            className="form-control-label"
                            htmlFor="validationCustom01"
                          >
                            Full Name
                          </label>
                          <Input
                            // defaultValue=""
                            value={this.state.customStyles.name}
                            id="validationCustom01"
                            placeholder="John Doe"
                            type="text"
                            valid={
                              this.state.customStyles.nameState === "valid"
                            }
                            invalid={
                              this.state.customStyles.nameState === "invalid"
                            }
                            onChange={(e) => this.customStylesForm(e, "name")}
                            autoComplete="off"
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Full Name Should Be At Least 5 Characters!
                          </div>
                        </Col>
                        <Col className="mb-3" md="4">
                          <label
                            className="form-control-label"
                            htmlFor="validationCustom02"
                          >
                            Email
                          </label>
                          <Input
                            // defaultValue=""
                            value={this.state.customStyles.email}
                            id="validationCustom02"
                            placeholder="john@doe.com"
                            type="email"
                            valid={
                              this.state.customStyles.emailState === "valid"
                            }
                            invalid={
                              this.state.customStyles.emailState === "invalid"
                            }
                            onChange={(e) => this.customStylesForm(e, "email")}
                            autoComplete="off"
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Invalid Email Address!
                          </div>
                        </Col>
                        <Col className="mb-3" md="4">
                          <label
                            className="form-control-label"
                            htmlFor="validationCustomUsername"
                          >
                            Status
                          </label>
                          <Select2
                            data-minimum-results-for-search="Infinity"
                            className="form-control"
                            defaultValue={this.state.customStyles.status}
                            valid={(
                              this.state.customStyles.statusState === "valid"
                            ).toString()}
                            invalid={(
                              this.state.customStyles.statusState === "invalid"
                            ).toString()}
                            onChange={(e) => this.customStylesForm(e, "status")}
                            options={{ placeholder: "Status" }}
                            data={[
                              { id: "enabled", text: "Enabled" },
                              { id: "disabled", text: "Disabled" },
                            ]}
                          />
                          <div className="valid-feedback">Looks Good!</div>
                        </Col>
                      </div>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          const { customStyles } = this.state
                          const { name, email, status } = customStyles
                          if (name && email && status) {
                            this.setState({ disableAddUser: true })
                            this.props
                              .addUser(customStyles, this.customersCollection)
                              .then((isCustomerAdded) => {
                                // const defVal = 'default';
                                let message = ""
                                if (isCustomerAdded) {
                                  message = "Customer Successfully Added!"
                                  return this.notify(
                                    "success",
                                    message,
                                    "Success"
                                  )
                                } else {
                                  message = "Customer Not Added!"
                                  return this.notify(
                                    "danger",
                                    message,
                                    "Warning"
                                  )
                                }
                              })
                          } else {
                            return this.notify(
                              "danger",
                              "Please Enter All The Details.",
                              "Warning"
                            )
                          }
                        }}
                        disabled={this.state.disableAddUser}
                      >
                        Add User
                      </Button>
                      {this.state.disableAddUser ? (
                        <Button
                          color="primary"
                          type="button"
                          onClick={() => {
                            const customStyles = this.state.customStyles
                            customStyles.name = ""
                            customStyles.nameState = null
                            customStyles.email = ""
                            customStyles.emailState = null
                            customStyles.status = ""
                            customStyles.statusState = null

                            return this.setState({
                              disableAddUser: false,
                              customStyles,
                            })
                          }}
                        >
                          Reset
                        </Button>
                      ) : null}
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    challenges: state.challenges,
    orgId: state.firebase.auth.uid,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (state, collection) => dispatch(addUser(state, collection)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails)
